import { render, staticRenderFns } from "./all.vue?vue&type=template&id=2fa66fec&scoped=true"
import script from "./all.vue?vue&type=script&lang=js"
export * from "./all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa66fec",
  null
  
)

export default component.exports